import React from "react";

const CallBack = () => {
  return <></>;
};

export default CallBack;
